import React from "react"
import { StrapiButtonProps } from "../StrapiButton"
import { LandingHero } from "./components/LandingHero"

type Props = {
  buttons: StrapiButtonProps[]
  headline?: string
}

export default (props: Props) => {
  return <LandingHero buttons={props.buttons} description={props.headline} />
}
